import { useState } from "react";
import * as api from "../../../utils/api/deliveryDocumentation";
import { Button, Checkbox, Select } from "../../ui";

const PHOTO_TYPES = [
  { value: "all", label: "كل الصور" },
  { value: "invoice", label: "فاتورة التطبيق" },
  { value: "order", label: "المنتجات قبل التغليف" },
  { value: "both", label: "الطلب المغلف + الفاتورة" },
  { value: "courier", label: "جوال المندوب" },
];

function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "delivery-documentation-export";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

function errorMessage(error) {
  if (error.status === 401 || error.status === 403) {
    return "لا تملك صلاحية إنشاء هذا التصدير.";
  }
  if (error.code === "EXPORT_TOO_LARGE") {
    return error.message || `حجم التصدير أكبر من الحد المسموح. قلّل نطاق الفلاتر ثم حاول مرة أخرى.`;
  }
  if (error.code === "NO_EXPORT_RECORDS" || error.code === "NO_EXPORT_PHOTOS") {
    return error.message || "لا توجد بيانات مطابقة للتصدير.";
  }
  return error.message || "تعذر إنشاء التصدير.";
}

export default function AdminExportActions({ filters }) {
  const [photoType, setPhotoType] = useState("all");
  const [includeDeleted, setIncludeDeleted] = useState(false);
  const [includeHistorical, setIncludeHistorical] = useState(false);
  const [state, setState] = useState({ type: "idle", message: "" });
  const busy = state.type === "generating";

  const payload = () => ({
    ...filters,
    photoType,
    includeDeleted,
    includeHistorical,
  });

  async function run(kind) {
    if (busy) return;
    setState({
      type: "generating",
      message:
        kind === "excel"
          ? "جاري تجهيز ملف Excel من الخادم..."
          : "جاري تجهيز ملف الصور ZIP من الخادم...",
    });
    try {
      const result =
        kind === "excel"
          ? await api.exportAdminExcel(payload())
          : await api.exportAdminPhotosZip(payload());
      saveBlob(
        result.blob,
        result.filename ||
          (kind === "excel"
            ? "delivery-documentation.xlsx"
            : "delivery-documentation-photos.zip"),
      );
      setState({ type: "success", message: "تم إنشاء التصدير وبدء التحميل." });
    } catch (error) {
      setState({ type: "error", message: errorMessage(error) });
    }
  }

  return (
    <div className="admin-export-actions" aria-live="polite">
      <Button
        variant="primary"
        appearance="filled"
        type="button"
        disabled={busy}
        loading={busy}
        onClick={() => run("excel")}
      >
        تصدير سجل التوثيق Excel
      </Button>
      <Select
        className="admin-compact-select"
        fullWidth={false}
        value={photoType}
        disabled={busy}
        onChange={(event) => setPhotoType(event.target.value)}
        aria-label="نوع صور التصدير"
        options={PHOTO_TYPES}
      />
      <Button
        variant="primary"
        appearance="filled"
        type="button"
        disabled={busy}
        onClick={() => run("zip")}
      >
        تصدير الصور ZIP
      </Button>
      <Checkbox
        checked={includeDeleted}
        disabled={busy}
        onChange={(event) => setIncludeDeleted(event.target.checked)}
        label="تضمين المحذوف"
      />
      <Checkbox
        checked={includeHistorical}
        disabled={busy}
        onChange={(event) => setIncludeHistorical(event.target.checked)}
        label="تضمين الصور التاريخية"
      />
      {state.message && (
        <div className={`admin-export-feedback ${state.type}`}>
          {state.message}
        </div>
      )}
    </div>
  );
}
